document.addEventListener("DOMContentLoaded", function () {
  const qtyInput = document.querySelector('input[name="quantity"]');
  if (!qtyInput) return;

  function getSalePriceEl() {
    return document.querySelector('.price__sale .price-item--sale');
  }

  function getRegularPriceEl() {
    return document.querySelector('.price__sale .price-item--regular');
  }

  function getBasePrice(el) {
    if (!el) return 0;
    return parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0;
  }

  let baseSale = 0;
  let baseRegular = 0;

  function setBasePrices() {
    const saleEl = getSalePriceEl();
    const regularEl = getRegularPriceEl();

    if (saleEl && !baseSale) {
      baseSale = getBasePrice(saleEl);
    }

    if (regularEl && !baseRegular) {
      baseRegular = getBasePrice(regularEl);
    }
  }

  function updateTotalPrice() {
    const qty = parseInt(qtyInput.value, 10) || 1;

    const saleEl = getSalePriceEl();
    const regularEl = getRegularPriceEl();

    if (saleEl && baseSale) {
      saleEl.textContent = `$${(baseSale * qty).toFixed(2)} USD`;
    }

    if (regularEl && baseRegular) {
      regularEl.textContent = `$${(baseRegular * qty).toFixed(2)} USD`;
    }
  }

  function refreshPrices() {
    setBasePrices();
    updateTotalPrice();
  }

  qtyInput.addEventListener("input", refreshPrices);
  qtyInput.addEventListener("change", refreshPrices);

  document.querySelectorAll('[name="plus"], [name="minus"]').forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(refreshPrices, 150);
    });
  });

  const priceContainer = document.querySelector('.price__container, .price');
  if (priceContainer) {
    const observer = new MutationObserver(() => {
      setTimeout(updateTotalPrice, 50);
    });

    observer.observe(priceContainer, {
      childList: true,
      subtree: true
    });
  }

  refreshPrices();
});
document.addEventListener("DOMContentLoaded", function () {
  function hideRechargeDeliveryDropdown() {
    document.querySelectorAll("recharge-subscription-widget").forEach((widget) => {
      const root = widget.shadowRoot;
      if (!root) return;

      const dropdown = root.querySelector(".rc-plans-dropdown");
      if (dropdown) {
        dropdown.style.setProperty("display", "none", "important");
      }
    });
  }

  hideRechargeDeliveryDropdown();

  const observer = new MutationObserver(() => {
    hideRechargeDeliveryDropdown();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(hideRechargeDeliveryDropdown, 500);
  setTimeout(hideRechargeDeliveryDropdown, 1000);
  setTimeout(hideRechargeDeliveryDropdown, 2000);
});
  (function() {
    function initProductAccordion() {
      const accordions = document.querySelectorAll('[data-product-accordion]');
      if (!accordions.length) return;

      accordions.forEach((accordion) => {
        const items = accordion.querySelectorAll('.product-accordion__item');

        items.forEach((item) => {
          const header = item.querySelector('.product-accordion__header');
          const content = item.querySelector('.product-accordion__content');

          if (!header || !content) return;

          header.addEventListener('click', function () {
            const isAlreadyOpen = item.classList.contains('is-active');

            items.forEach((otherItem) => {
              otherItem.classList.remove('is-active');

              const otherHeader = otherItem.querySelector('.product-accordion__header');
              const otherContent = otherItem.querySelector('.product-accordion__content');

              if (otherHeader) otherHeader.setAttribute('aria-expanded', 'false');
              if (otherContent) otherContent.style.display = 'none';
            });

            if (!isAlreadyOpen) {
              item.classList.add('is-active');
              header.setAttribute('aria-expanded', 'true');
              content.style.display = 'block';
            }
          });
        });
      });
    }

    document.addEventListener('DOMContentLoaded', initProductAccordion);
    document.addEventListener('shopify:section:load', initProductAccordion);
  })();

  document.addEventListener('DOMContentLoaded', function () {
    var articleContent = document.getElementById('article-content');
    var tocWrapper = document.getElementById('article-toc-wrapper');
    var tocList = document.getElementById('article-toc-list');

    if (!articleContent || !tocWrapper || !tocList) return;

    var headings = articleContent.querySelectorAll('h2');
    if (!headings.length) return;

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var headingText = heading.textContent.trim().toLowerCase();
        var headingId = headingText
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');

        if (!headingId) {
          headingId = 'section-' + (index + 1);
        }

        if (document.getElementById(headingId)) {
          headingId = headingId + '-' + (index + 1);
        }

        heading.id = headingId;
      }

      var li = document.createElement('li');
      li.className = 'article-toc__item';

      var a = document.createElement('a');
      a.className = 'article-toc__link';
      a.href = '#' + heading.id;
      a.textContent = heading.textContent.trim();

      li.appendChild(a);
      tocList.appendChild(li);
    });

    tocWrapper.style.display = 'block';
  });

document.addEventListener("DOMContentLoaded", function() {

  const faqItems = document.querySelectorAll(".faq-section .faq-item");

  faqItems.forEach(function(item){

    const question = item.querySelector("h3");

    if(!question) return;

    question.addEventListener("click", function(){

      faqItems.forEach(function(other){
        if(other !== item){
          other.classList.remove("open");
        }
      });

      item.classList.toggle("open");

    });

  });

});
